import { CARGAR_IMPORTACION } from './actionTypes';
import { completar_String } from '../../funciones_globales/format';
import { formatearFecha } from '../../funciones_globales/format';
import global_axios from '../../funciones_globales/interaccionapi';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA, INICIALIZAR_FORM } from '../generales/actionTypes';

export const cargar_Importacion = (importacion) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/importaciones/' + importacion,
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {			
			var temp;

			if(response.data.fec_contable!==null){
				temp= temp = response.data.fec_contable
				response.data.fec_contable = formatearFecha(temp);
			}
			
			if(response.data.fec_confirmacion!==null){
				temp = response.data.fec_confirmacion
				response.data.fec_confirmacion = formatearFecha(temp);
			}

			if(response.data.fec_embarque!==null){
				temp = response.data.fec_embarque
				response.data.fec_embarque = formatearFecha(temp);
			}
			
			if(response.data.fec_llegada_aduana!==null){
				temp = response.data.fec_llegada_aduana
				response.data.fec_llegada_aduana = formatearFecha(temp);
			}
			
			if(response.data.fec_recepcion_ofi!==null){
				temp = response.data.fec_recepcion_ofi
				response.data.fec_recepcion_ofi = formatearFecha(temp);
			}

			dispatch({
				type: CARGAR_IMPORTACION,
				data: response.data	
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar importación', mensaje: msgError}
			});
		});
	}
}

export const cargar_ValoresIniciales = () => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/secuenciales/Importacion',
		}

		return global_axios(config_request)
		.then( response => {						
			let cod_secuencial = completar_String(response.data.codigo, '0', 6);			
			let fec_contable = ''		
			dispatch({
				type: INICIALIZAR_FORM,
				data: {	codigo: cod_secuencial,
                        forma_pago: 'CR',
						fec_contable
					}			
			})
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;			
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar valores iniciales de importación', mensaje: msgError}
			});
		});
	}
}
